<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;"></h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Tanımlar</li>
            <li class="breadcrumb-item active"><a routerLink="/contract">Abonelikler</a></li>
            <li class="breadcrumb-item active">Abonelik Güncelle</li>
        </ol>
    </div>
    <div class="container">
        <div class="card mb-4">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h3 class="m-0 font-weight-bold" style="color: #1A355E;">Abonelik Güncelle</h3>
            </div>
            <br>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="update()">
                    <div>
                        <fieldset>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Abonelik No</span></label>
                                    <input pInputText type="txt" class="form-control" formControlName="contractNumber"
                                        readonly="true" autofocus />
                                </div>
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Müşteri</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <p-dropdown [options]="customers$ | async" [style]="{'width': '100%'}" [virtualScroll]="true" [itemSize]="31"
                                                optionLabel="definitioN_" optionValue="logicalref" [filter]="true"
                                                [filterBy]="'code,definitioN_'" placeholder="Müşteri Seçimi Yapınız."
                                                [showClear]="true" formControlName="customerId">
                                                <ng-template let-customers pTemplate="item">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-3">
                                                            <span class="badge badge-info">
                                                                {{customers.code}}</span>
                                                        </div>
                                                        <div class="col-sm-12 col-md-9">
                                                            {{customers.definitioN_}}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('customerId').hasError('required')&& form.get('customerId').touched">Müşteri
                                            boş geçilemez!</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Bayi</span></label>
                                    <div class="w-100">
                                        <p-dropdown [options]="dealers$ | async" [style]="{'width': '100%'}"
                                        [virtualScroll]="true" [itemSize]="31" optionLabel="definitioN_"
                                        optionValue="logicalref" [filter]="true" [filterBy]="'code,definitioN_'"
                                        placeholder="Bayi Seçimi Yapınız." [showClear]="true"
                                        formControlName="dealerId">
                                        <ng-template let-customers pTemplate="item">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-3">
                                                    <span class="badge badge-info">
                                                        {{customers.code}}</span>
                                                </div>
                                                <div class="col-sm-12 col-md-9">
                                                    {{customers.definitioN_}}
                                                </div>
                                            </div>
                                        </ng-template>
                                    </p-dropdown>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Abonelik Tipi</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <p-dropdown [options]="contractTypes$ | async" [style]="{'width': '100%'}"
                                                optionLabel="contractTypeName" optionValue="id" [filter]="true"
                                                placeholder="Abonelik Tipi Seçimi Yapınız." [showClear]="true"
                                                formControlName="contractTypeId">
                                            </p-dropdown>
                                        </div>
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('contractTypeId').hasError('required')&& form.get('contractTypeId').touched">Abonelik
                                            Tipi boş geçilemez!</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Proje</span></label>
                                    <div class="w-100">
                                        <p-dropdown [options]="projects$ | async" [style]="{'width': '100%'}"
                                            optionLabel="name" optionValue="logicalref" [filter]="true"
                                            placeholder="Proje Seçimi Yapınız." [showClear]="true"
                                            formControlName="projectId">
                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Portal</span></label>
                                    <div class="w-100">
                                        <p-dropdown [options]="portals$ | async" [style]="{'width': '100%'}"
                                            optionLabel="portalName" optionValue="id" [filter]="true"
                                            placeholder="Portal Seçimi Yapınız." [showClear]="true"
                                            formControlName="portalId">
                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Hizmet</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <p-dropdown [options]="services$ | async" [style]="{'width': '100%'}" [virtualScroll]="true" [itemSize]="31"
                                                optionLabel="definitioN_" optionValue="logicalref" [filter]="true"
                                                [filterBy]="'code,definitioN_'" placeholder="Hizmet Seçimi Yapınız."
                                                [showClear]="true" formControlName="serviceId">
                                                <ng-template let-services pTemplate="item">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-3">
                                                            <span class="badge badge-info">
                                                                {{services.code}}</span>
                                                        </div>
                                                        <div class="col-sm-12 col-md-9">
                                                            {{services.definitioN_}}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('serviceId').hasError('required')&& form.get('serviceId').touched">Hizmet
                                            boş geçilemez!</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Hizmet Birim Fiyatı</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <input pInputText type="number" class="form-control"
                                                formControlName="serviceUnitPrice" autofocus />
                                        </div>
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('serviceUnitPrice').hasError('required')&& form.get('serviceUnitPrice').touched">Hizmet
                                            Birim Fiyatı boş geçilemez!</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Komisyon Bedeli</span></label>
                                    <div class="w-100">
                                        <input pInputText type="number" class="form-control"
                                            formControlName="commissionPrice" autofocus />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Para Birimi</span></label>
                                    <div class="w-100">
                                        <p-dropdown [options]="currencyUnits" [style]="{'width': '100%'}"
                                            optionLabel="name" optionValue="name" formControlName="currencyUnit">

                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger" style="font-size:1rem;">**
                                            Başlangıç Tarihi</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <input type="date" class="form-control" formControlName="startDate">
                                            <small class="form-text text-danger"
                                                *ngIf="form.get('startDate').hasError('required')&& form.get('startDate').touched">Başlangıç
                                                Tarihi
                                                seçimi zorunludur!</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger" style="font-size:1rem;">**
                                            Bitiş Tarihi</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <input type="date" class="form-control" formControlName="endDate">
                                            <small class="form-text text-danger"
                                                *ngIf="form.get('endDate').hasError('required')&& form.get('endDate').touched">Bitiş
                                                Tarihi
                                                seçimi zorunludur!</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger" style="font-size:1rem;">**
                                            Faturalama Tarihi</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <input type="date" class="form-control" formControlName="invoiceDate">
                                            <small class="form-text text-danger"
                                                *ngIf="form.get('invoiceDate').hasError('required')&& form.get('invoiceDate').touched">Faturalama
                                                Tarihi
                                                seçimi zorunludur!</small>
                                        </div>
                                    </div>
                                </div>

                             
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Notlar</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="notes"
                                        autofocus />

                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Rapor Etiketi 1</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="reportTag1"
                                        autofocus />

                                </div>
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Rapor Etiketi 2</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="reportTag2"
                                        autofocus />

                                </div>
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Şehir</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="reportTag3"
                                        autofocus />

                                </div>


                            </div>
                            <div class="col-md-12 text-right">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                    <button pButton type="button" class="p-button-rounded p-button-danger"
                                        label="Vazgeç" routerLink="/contract"></button>
                                    <button pButton type="submit" class="p-button-rounded p-button-success"
                                        label="Kaydet" [disabled]="!form.valid"></button>
                                </div>
                            </div>

                        </fieldset>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>